import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-redux-i18n';
import { SidePanel } from 'front-onceforall-core';
import { projectService } from '../../../../services/project/ProjectService';
import { DOCUMENT_CATEGORY } from '../../../../utils/constant';
import { captureError } from '../../../../utils/log';
import ProjectDocumentsForm from '../../../projectCreate/ProjectDocumentsForm';
import ProjectDocumentsView from './ProjectDocumentsView';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export const ProjectDocumentsContainer = props => {
  const [documents, setDocuments] = React.useState([]);
  const [isPanelOpen, setIsPanelOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState(false);
  let triggerClosePanel = () => {};
  const fetchRequiredDocumentTypes = projectId => {
    setLoading(true);
    projectService.getRequiredDocumentTypesByProjectId(projectId).then(documents => {
      setDocuments(documents);
      setError(false);
    }).catch(error => {
      captureError(`[ProjectDocumentsContainer][fetchRequiredDocumentTypes] projectService.getRequiredDocumentTypesByProjectId error: ${error}`);
      setError(true);
    }).finally(() => {
      setLoading(false);
    });
  };
  const handleDocumentTypesEdition = documentTypes => {
    setLoading(true);
    const documentTypesToSave = {
      requiredDocumentTypeCodes: documentTypes.filter(doc => doc.category !== DOCUMENT_CATEGORY.CUSTOM).map(doc => doc.code),
      requiredCustomDocumentTypes: documentTypes.filter(doc => doc.category === DOCUMENT_CATEGORY.CUSTOM)
    };
    projectService.editDocumentTypes(props.projectId, documentTypesToSave).then(response => {
      fetchRequiredDocumentTypes(props.projectId);
      props.actions.addSuccess(/*#__PURE__*/_jsx(Translate, {
        value: "project.edit.success"
      }));
      props.onProjectUpdate(prevProject => ({
        ...prevProject,
        requiredDocumentTypeCodes: response.requiredDocumentTypeCodes
      }));
    }).catch(() => {
      props.actions.addError(/*#__PURE__*/_jsx(Translate, {
        value: "project.edit.failed"
      }));
    }).finally(() => {
      setLoading(false);
    });
    triggerClosePanel();
  };
  React.useEffect(() => {
    if (props.projectId) {
      fetchRequiredDocumentTypes(props.projectId);
    } else {
      setError(true);
    }
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(ProjectDocumentsView, {
      documents: documents,
      isProjectEditionAllowed: props.isProjectEditionAllowed,
      loading: loading,
      error: error,
      onEditButtonClick: () => setIsPanelOpen(true)
    }), isPanelOpen && /*#__PURE__*/_jsx(SidePanel, {
      setCloseTrigger: closeFunction => {
        triggerClosePanel = closeFunction;
      },
      onClose: () => setIsPanelOpen(false),
      children: /*#__PURE__*/_jsx(ProjectDocumentsForm, {
        projectId: props.projectId,
        onValidate: handleDocumentTypesEdition,
        isOpen: isPanelOpen,
        loading: loading,
        documents: documents,
        onCancel: triggerClosePanel,
        displayEditMessage: true
      })
    })]
  });
};
ProjectDocumentsContainer.propTypes = {
  actions: PropTypes.object,
  projectId: PropTypes.number.isRequired,
  isProjectEditionAllowed: PropTypes.bool.isRequired,
  error: PropTypes.bool,
  loading: PropTypes.bool,
  onEditButtonClick: PropTypes.func,
  onProjectUpdate: PropTypes.func
};
export default ProjectDocumentsContainer;